<template>
  <v-card>
    <v-toolbar card color="white">
      <v-text-field
        v-model="localFilters.match"
        :placeholder="$t('action.buttons.search')"
        flat
        hide-details
        prepend-icon="search"
        solo
      />
      <meta-button
        v-if="can('create', 'entity')"
        type="new"
        @click="$emit('form')"
      />
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">
      <v-data-table
        :items="formatedList"
        :headers="headers"
        :rows-per-page-items="[10, 25, 50]"
        :loading="loading"
        :total-items="localPagination.totalItems"
        :pagination.sync="localPagination"
        disable-initial-sort
      >
        <!--         -->
        <template slot="items" slot-scope="props">
          <td class="text-xs-center px-0">
            <v-tooltip top>
              <template #activator="{ on }">
                <v-icon
                  color="success"
                  class="mr-1"
                  @click="sendNotification(props.item._id)"
                  v-on="on"
                >
                  mail
                </v-icon>
              </template>
              <span>{{ $t('action.buttons.sendNotification') }}</span>
            </v-tooltip>
            <v-icon color="primary" class="mr-1" @click="view(props.item._id)">
              visibility
            </v-icon>
            <v-icon
              v-if="can('edit', 'entity', props.item)"
              color="success"
              class="mr-1"
              @click="setOne(props.item._id)"
            >
              edit
            </v-icon>
            <v-icon
              v-if="can('delete', 'entity', props.item)"
              color="error"
              @click="ifDelete(props.item._id)"
            >
              delete
            </v-icon>
          </td>
          <td class="text-xs-center">
            <button-state :state="props.item.active" />
          </td>
          <td class="text-xs-center">
            <v-avatar size="32">
              <img :src="props.item.logo" alt />
            </v-avatar>
          </td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.townId }}</td>
          <!-- <td>{{props.item.totalUsers}}</td>
          <td>{{props.item.totalTeams}}</td>-->
          <td class="text-xs-center">
            {{ props.item.createdAt }}
          </td>
          <td>{{ props.item.createdBy }}</td>
          <td class="text-xs-center">
            <i
              class="icon material-icons cursor"
              @click="openUpdated(props.item._id)"
              >visibility</i
            >
          </td>
        </template>
      </v-data-table>
    </v-card-text>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete(idDelete)"
    />
    <dialog-updated-record :dialog.sync="dialogUpdated" :updated="updated" />
    <dialog-notification-form
      v-if="dialogNotification"
      :entity-id="entityId"
      :dialog="true"
      @close="dialogNotification = false"
    />
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogNotificationForm from '@/components/apps/notifications/FormManager'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import DialogUpdatedRecord from '@/components/widgets/dialog/DialogUpdatedRecord'

export default {
  name: 'EntityList',
  components: { DialogDelete, DialogUpdatedRecord, DialogNotificationForm },
  data() {
    return {
      search: '',
      idDelete: '',
      dialogDelete: false,
      dialogUpdated: false,
      dialogNotification: false,
      entityId: '',
    }
  },
  watch: {
    dialogUpdated(val) {
      if (!val) this.reset()
    },
    'filters.match': {
      handler: function () {
        if (this.localPagination.page !== 1) this.localPagination.page = 1
        this.debounceFetch('entities')
      },
    },
    'localPagination.page': {
      handler: function () {
        this.debounceFetch('entities')
      },
    },
    'localPagination.rowsPerPage': {
      handler: function () {
        this.debounceFetch('entities')
      },
    },
    'localPagination.sortBy': {
      handler: function () {
        this.debounceFetch('entities')
      },
    },
    'localPagination.descending': {
      handler: function () {
        this.debounceFetch('entities')
      },
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.entities.loading,
      selected: (state) => state.entities.selected,
      filters: (state) => state.entities.filters,
      pagination: (state) => state.entities.pagination,
    }),
    ...mapGetters({
      formatedList: 'entities/formatedList',
    }),
    headers() {
      return [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.state'),
          align: 'center',
          value: 'active',
        },
        {
          text: this.$t('fields.global.logo'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.name'),
          value: 'name',
        },
        {
          text: this.$tc('models.town'),
          value: 'townId',
        },
        // {
        //   text: this.$tc('models.user', 2),
        //   align: 'center',
        //   value: 'totalUsers'
        // },
        // {
        //   text: this.$tc('models.team', 2),
        //   align: 'center',
        //   value: 'totalTeams'
        // },
        {
          text: this.$t('fields.global.createdAt'),
          align: 'center',
          value: 'createdAt',
        },
        {
          text: this.$t('fields.global.createdBy'),
          value: 'createdBy',
        },
        {
          text: this.$t('titles.global.updates'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    localFilters: {
      get() {
        return this.filters
      },
      set(value) {
        this.$store.commit('entities/setFilters', value)
      },
    },
    localPagination: {
      get() {
        return this.pagination
      },
      set(value) {
        this.$store.commit('entities/setPagination', value)
      },
    },
    updated() {
      if (!Array.isArray(this.selected.updated)) return []

      return this.selected.updated
    },
  },
  methods: {
    ...mapActions({
      fetchOne: 'entities/fetchOne',
      setDelete: 'entities/delete',
      reset: 'entities/reset',
      fetchTeams: 'teams/fetchList',
      fetchUsers: 'users/fetchList',
      fetchEntityCameras: 'entities/fetchCameras',
    }),
    view(id) {
      this.fetchTeams({ entityId: id })
      this.fetchUsers({ entity: id, limit: 0 })
      this.fetchOne(id).then(() => this.$emit('view'))
    },
    setOne(id) {
      this.$emit('clear')
      this.fetchTeams({ entityId: id })
      this.fetchOne(id).then(() => this.$emit('form'))
      this.fetchEntityCameras(id)
    },
    openUpdated(id) {
      this.fetchOne(id).then(() => (this.dialogUpdated = true))
    },
    ifDelete(id) {
      this.idDelete = id
      this.dialogDelete = true
    },
    _setDelete(id) {
      this.setDelete(id).finally(() => (this.dialogDelete = false))
    },
    sendNotification(item) {
      this.entityId = item
      this.dialogNotification = true
    },
  },
}
</script>
